import React, { memo, ChangeEvent } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { ICarrierReference } from 'types/carrier'
import ReferenceEntryForm from './ReferenceEntryForm'

interface IAddReferenceEntryProps {
  reference: ICarrierReference
  updateNewReference: (e: { value: string; id: string }) => void
  addNewReference: () => void
}

const AddReferenceEntry = memo<IAddReferenceEntryProps>(
  ({ addNewReference, reference, updateNewReference }) => {
    const updateNewReferenceHandler = (e: ChangeEvent<HTMLInputElement>) => {
      const event = { value: e.target.value, id: e.target.id }
      return updateNewReference(event)
    }

    return (
      <div className='row'>
        <ReferenceEntryForm
          type='add'
          reference={reference}
          inputChange={updateNewReferenceHandler}
        />
        <div className='col-xs-12 mt2'>
          <Button color='primary' onClick={addNewReference} data-test='add-reference'>
            Add Reference
          </Button>
        </div>
        <div className='col-xs-12'>
          <hr />
        </div>
      </div>
    )
  }
)

export default AddReferenceEntry
